<template>
  <div v-if="canExport">
        <el-tooltip
          placement="top"
          :content="$t('information.export_report_button')"
        >
          <chip class="export-lesson" @click.native="getAllExportData">
            {{$t('common.export_report')}}
          </chip>
        </el-tooltip>
    
    <export-report
      :dialogVisible="showExportReportModal"
      v-on:closed="showExportReportModal = false"
    />
  </div>
</template>

<script>
  import ExportReport from '@/components/modals/organizations/ExportReport'
  import Chip from '@/components/common/Chip'
  import { format, toDate, startOfMonth } from 'date-fns'
  import { mapGetters, mapActions, mapState } from 'vuex'
  import { warningMessage } from '@/utils/messages'
  export default {
    components: {
      Chip,
      ExportReport
    },
    props: {
      startDate: {
        default: () => startOfMonth(Date.now())
      },
      endDate: {
        default: () => toDate(Date.now())
      },
      canExport: {
          default: false
      }
    },
    data() {
      return {
        showExportReportModal: false
      }
    },
    methods: {
      getAllExportData() {
        try {
            let options = {
                email: this.$store.state.user.userInfo.email,
                from: this.startDate,
                to: this.endDate
            }
            this.showExportReportModal = true
            return this.exportReport(options)
        }
        catch (error) {
            warningMessage(this.$t('common.generic_error_message'))(this)
        }
      },
      ...mapActions('organization',[
        "exportReport",
      ]),
    }
  }
</script>

<style lang="scss" scoped>
@import '../../scss/_colors.scss';
.export-lesson {
  margin-right: 10px;
  padding: 11px 11px;
}
</style>
